"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Separator = function Separator(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledSeparator, props);
};
var StyledSeparator = _styledComponents["default"].hr.withConfig({
  displayName: "Separator__StyledSeparator",
  componentId: "sc-1du9zsi-0"
})(["background:", ";height:1px;border:none;margin:4rem 0;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.neutral['20'];
});
var _default = exports["default"] = Separator;
//# sourceMappingURL=Separator.js.map